import { Injectable, signal } from '@angular/core';
import { EVIDENCE, EVIDENCE_SOURCES } from '../services/mock-data';
import type { EvidenceData, EvidenceSource, EvidenceType } from '../models/evidence.model';

@Injectable({ providedIn: 'root' })
export class EvidenceStore {
  readonly activeEvidence = signal<EvidenceType>('authority');
  readonly activeSource = signal<EvidenceSource | null>(null);
  readonly data = signal<EvidenceData | null>(null);
  readonly sources = signal<EvidenceSource[]>([]);

  /** Loads evidence for an account (synchronous mock; swap for EvidenceService later). */
  load(accountId: string): void {
    this.data.set(EVIDENCE[accountId] ?? null);
    this.sources.set(EVIDENCE_SOURCES[accountId] ?? []);
    this.activeSource.set(null);
  }

  selectEvidence(type: EvidenceType): void {
    this.activeEvidence.set(type);
  }

  openSource(sourceId: string): void {
    const source = this.sources().find((s) => s.id === sourceId);
    this.activeSource.set(source ?? null);
    if (source && this.data()) {
      this.activeEvidence.set('loss');
    }
  }

  closeSource(): void {
    this.activeSource.set(null);
  }
}
